import { z } from "zod";

export const broadcastSongSchema = z.object({
  workcode: z.string(),
  title: z.string(),
  tc: z.string().optional(),
});

const baseSchema = z.object({
  song: z.string().min(1, "Please choose a song"),
  medium: z.enum(["Radio", "TV"], {
    errorMap: () => ({ message: "Please select a medium" }),
  }),
  station: z.string().min(1, "Please enter a station or channel"),
  program: z.string().optional(),
  country: z.string().min(1, "Please select a country"),
  dateAired: z
    .string()
    .min(1, "Please select a date")
    .refine(d => !Number.isNaN(new Date(d).getTime()), "Invalid Date"),
  evidence: z.string().min(1, "Please record evidence"),
});

export function createBroadcastFormSchema() {
  return baseSchema.extend({
    dateAired: z
      .string()
      .min(1, "Please select a date")
      .refine(d => !Number.isNaN(new Date(d).getTime()), "Invalid Date")
      .refine(d => new Date(d) <= new Date(), "Date cannot be in the future"),
  });
}

export type BroadcastFormValues = z.infer<ReturnType<typeof createBroadcastFormSchema>>;
